<template>
  <div class="form-group">
    <label for="guides supplémentaires">Guides supplémentaires
      <span v-if="this.tooltip === true" class="tooltips" data-container="body" data-placement="right" data-html="true" :data-original-title="message">
          <i class="icon-info"></i>
      </span>
    </label>
    <select :name="name + '[]'" v-model="value" class="form-control" multiple>
        <option v-for="(value, key) in datas" :value="key">{{ value }}</option>
    </select>
  </div>
</template>

<script>
export default {

  name: 'selectList',
  props: ['datas', 'name', 'message', 'tooltip', 'selected'],
  data () {
    return {
        'value': Object.assign([], this.selected)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
